$(document).ready(function () {
    'use strict';

    var readMoreScroll = $(".js_readMoreScroll");

    if (readMoreScroll.length > 0) {
        readMoreScroll.click(function() {
            $('html, body').animate({
                scrollTop: $(".carzInfoBlock.bottomBlock").offset().top
            }, 500);
        });
    }
});


